module.exports = __webpack_public_path__ + "static/media/messageBtn.a2a2cc4e.svg";